angular.module("app").controller("EditSkinPageController", [
    '$scope',
    'preloadedSkinData',
    'preloadedLanguages',
    'deepCompare',
    'generalService',
    'logger',
    'errorHandler',
    function ($scope, preloadedSkinData, preloadedLanguages, deepCompare, generalService, logger, errorHandler) {
        var sourceData = angular.copy(preloadedSkinData.skin);

        $scope.skin = angular.extend({}, sourceData);

        $scope.tooltip = {
            id: "",
            basehost: "",
            url: "",
            name:""
        };

        $scope.languages = {
            all: angular.copy(preloadedLanguages.languages),
            selected: function () {
                var formattedLanguages = [];
                sourceData.languages.forEach(function (value) {
                    formattedLanguages.push({id: value})
                });
                return formattedLanguages
            }()
        };

        $scope.save = function () {
            var requestData = {},
                fetchedData = fetchRequestData(),
                changes = deepCompare.getChanges(angular.copy(sourceData), fetchedData.skin);

            changes.languages && (changes.languages = fetchedData.skin.languages);
            requestData.skin = changes;
            requestData.skin.id = $scope.skin.id;
            generalService.editSkin(requestData).then(
                function (response) {
                    if (response.status === "ok") {
                        logger.logSuccess("Skin has been successfully updated");
                        $scope.skin = angular.copy(fetchedData.skin);
                        sourceData = angular.copy(fetchedData.skin);
                        $scope.edit_skin_form && $scope.edit_skin_form.$setPristine && $scope.edit_skin_form.$setPristine()
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.allowUpdate = function () {
            var changes = deepCompare.getChanges(angular.copy(sourceData), fetchRequestData().skin);
            return !!changes
        };

        function fetchRequestData() {
            var requestData = {
                skin: angular.copy($scope.skin)
            };

            requestData.skin.languages = [];

            $scope.languages.selected.forEach(function (languageObj) {
                requestData.skin.languages.push(languageObj.id)
            });

            return requestData
        }

    }
]);